jQuery(document).ready(function($){

  /* mobile menu trigger */
  $('#hamburgerMenu').on('click', function(e){
    e.preventDefault();

    nav = $('.mainMenuContainer');

    if($(this).hasClass('opened')){
      $('html,body').css({'overflow-y':'auto'});
      setTimeout(function(){
        $('body').removeClass('menuOpened');
      }, 300);
      $(this).removeClass('opened');
      nav.animate({ 'right':'-105vw' }, 300, 'linear');
    }
    else{
      $('html,body').css({'overflow-y':'hidden'});
      setTimeout(function(){
        $('body').addClass('menuOpened');
      }, 300);
      $(this).addClass('opened');
      nav.animate({ 'right':'0' }, 300, 'linear');
    }
  })



  /* age checker */
  if($.cookie('age')!='isok'){
    $('#agechecker').fadeIn();
    $('html,body').css({'overflow':'hidden'});
  }

  $('#agechecker .over21').on('click', function(){
    $('html,body').css({'overflow':'auto'});
    $('#agechecker').fadeOut();
    $.cookie('age', 'isok');
  })

  $('#agechecker .under21').on('click', function(){
    window.location.href = "https://www.google.com/";
  })



  /* hide price if subscription is available */
  if($('body').hasClass('template-product')){
    let interval = setInterval(function(){
      if($('.sealsubs-container').length>0){
        $('body').addClass('slsloaded');
        clearInterval(interval);
      }
    }, 200);

    setTimeout(function(){
      clearInterval(interval);
    }, 5000);
  }


  /* sticky header */
  var page = $('#head'),
  howFar = 30;

  const changeMenu = () => {
    if($(document).scrollTop() > howFar){
      page.addClass('scrolled');
    }
    else{
      page.removeClass('scrolled');     
    }
  }
  changeMenu();
  $(document).scroll(changeMenu);



})